function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from "react-redux";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { assignImageEditorImage64, processImage } from "../../../redux/ui/imageEditor/imageEditorActions";
import styled from "styled-components";
import BlankSpace from "../styled/BlankSpace";
import FileSelect from "./FileSelect";
import { Button } from "./Buttons";
import { TmRightSubmitButton } from "../form/components/TmSubmitButton";
const StyledReactCropWrapper = styled.div`
  text-align: center;
`;

class ImageEditor extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      crop: this.props.crop || {
        unit: '%',
        width: 30
      }
    });

    _defineProperty(this, "onImageLoaded", image => {
      this.imageRef = image;
    });

    _defineProperty(this, "onCropComplete", crop => {
      this.makeClientCrop(crop);
    });

    _defineProperty(this, "onCropChange", (crop, percentCrop) => {
      // You could also use percentCrop:
      // this.setState({ crop: percentCrop });
      this.setState({
        crop
      });
    });
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop);
      this.props.processImage({
        processedImage64: croppedImageUrl
      });
    }
  }

  getCroppedImg(image, crop) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    return canvas.toDataURL('image/jpeg');
  }

  render() {
    const {
      crop,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BlankSpace, null), /*#__PURE__*/React.createElement(StyledReactCropWrapper, null, /*#__PURE__*/React.createElement(ReactCrop, _extends({
      src: this.props.image64,
      crop: this.state.crop,
      onImageLoaded: this.onImageLoaded,
      onComplete: this.onCropComplete,
      onChange: this.onCropChange
    }, props))), /*#__PURE__*/React.createElement(BlankSpace, {
      rem: 3
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileSelect, {
      onSelectFile: this.props.onSelectFile,
      accept: 'image/*'
    }, /*#__PURE__*/React.createElement(Button, {
      color: 'info',
      type: 'button'
    }, "Select File")), /*#__PURE__*/React.createElement(TmRightSubmitButton, {
      type: 'button',
      loading: this.props.loading ? 1 : 0,
      onClick: this.props.handleImageSubmit
    })), /*#__PURE__*/React.createElement(BlankSpace, null));
  }

}

function mapStateToProps(state) {
  return {
    image64: state.ui.imageEditor.image64,
    loading: state.ui.form.imageEditor.loading
  };
}

export default connect(mapStateToProps, {
  assignImageEditorImage64,
  processImage
})(ImageEditor);